// cpfPaciente,  
// nomePaciente,
// sexoPaciente,
// dataNascimentoPaciente,
// emailPaciente, 
// dddCelularPaciente,
// numeroCelularPaciente, 

const initialState = {
    dataNascimento: null,
    cpfPaciente: '',
    nomePaciente: '',
    sexoPaciente: '',
    dataNascimentoPaciente: '',
    emailPaciente: '',
    dddCelularPaciente: '', 
    numeroCelularPaciente: ''
}

export default initialState